// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__okxdg","comment":"styles_comment__QGVuW"};